import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import cx from "classnames";
import React from "react";
import { connect } from "react-redux";

import { blogsArticleEditUrl } from "@/mk2/apps/blogs/urls";
import PostMenuTrigger from "@/mk2/apps/forum/components/PostMenuTrigger";
import { POST_DETAIL_MENU_MORE } from "@/mk2/apps/forum/containers/PostDetail/PostDetail.constants";
import { MenuItem } from "@/mk2/components/menu/MenuItem";
import { Menu } from "@/mk2/containers/Menu/Menu";
import { menuToggle } from "@/mk2/containers/Menu/Menu.actions";
import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import { url } from "@/mk2/helpers/urls";
import { AppState, getRequestPermissions, getRequestUser } from "@/mk2/reducers";
import { BlogPostEntity, UserEntity } from "@/mk2/schemas";
import { FORUM_POST_EDIT_MENU } from "@/mk/autogenerated/translations/TestingPostMenu.c4beea9cd4e98a295146a708d8352ee5";

import styles from "./TestingPostMenu.mscss";

interface OwnProps {
    className?: string;
    post: BlogPostEntity;
}

interface StateProps {
    requestUser: UserEntity;
    permissions: string[];
}

interface DispatchProps {
    onToggleMenuMore();
}

type Props = OwnProps & StateProps & DispatchProps;

class TestingPostMenu extends React.PureComponent<Props> {
    public render() {
        const { post, onToggleMenuMore, className } = this.props;

        return (
            <Menu
                className={cx(styles.TestingPostMenu, className)}
                menuId={POST_DETAIL_MENU_MORE}
                trigger={<PostMenuTrigger onClick={onToggleMenuMore} />}
                triggerShadow={false}
            >
                <MenuItem
                    label={FORUM_POST_EDIT_MENU}
                    icon={faPencil}
                    className={styles.TestingPostMenu__item}
                    link={url(blogsArticleEditUrl, {
                        username: post.author.username,
                        articleSlug: post.slug,
                    })}
                />
            </Menu>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        permissions: getRequestPermissions(state),
        requestUser: getRequestUser(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onToggleMenuMore: () => menuToggle(POST_DETAIL_MENU_MORE),
};

export default connect(mapStateToProps, mapDispatchToProps)(TestingPostMenu);
